<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Life Buoy" class="d-icon d-icon--life-buoy" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><g :clip-path="`url(#${uniqueID}a)`"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 .5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11Zm0 10a4.48 4.48 0 0 1-2.809-.984l1.43-1.43c.396.262.87.414 1.379.414.51 0 .983-.152 1.379-.414l1.43 1.43A4.48 4.48 0 0 1 6 10.5ZM10.5 6a4.48 4.48 0 0 0-.984-2.809l-1.43 1.43c.262.396.414.87.414 1.379 0 .51-.152.983-.414 1.379l1.43 1.43A4.48 4.48 0 0 0 10.5 6ZM6 3.5c-.51 0-.983.152-1.379.414l-1.43-1.43A4.481 4.481 0 0 1 6 1.5a4.48 4.48 0 0 1 2.809.984l-1.43 1.43A2.488 2.488 0 0 0 6 3.5Zm-3.516-.309A4.481 4.481 0 0 0 1.5 6a4.48 4.48 0 0 0 .984 2.809l1.43-1.43A2.488 2.488 0 0 1 3.5 6c0-.51.152-.983.414-1.379l-1.43-1.43ZM4.5 6a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z" fill="currentColor"/></g><defs><clipPath :id="`${uniqueID}a`"><path fill="#fff" d="M0 0h12v12H0z"/></clipPath></defs></svg>
</template>

<script>
import { getUniqueString } from '@/src/utils';
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconLifeBuoy',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
    this.uniqueID = getUniqueString();
  },
};
</script>
